import { UnorderedListOutlined, TableOutlined, BorderHorizontalOutlined } from '@ant-design/icons'
import { useState, useEffect, useCallback } from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import { useLocation, useParams, useNavigate } from 'react-router-dom'
import queryString from 'query-string'

import Loading from 'components/loading/Loading'
import { Meta, NoProduct, HtmlContent } from 'components/display'
import BreadcrumbView from 'pages/Breadcrumb'
import { message, product } from 'utils'

import ProductGroup from 'pages/product.list/ProductGroup'
import ProductViewGroup from 'pages/product.list/ProductViewGroup'
import ProductView from 'pages/product.list/ProductView'

const ProductList = (props) => {
  const [loading, setLoading] = useState(false)
  const [content, setContent] = useState({})
  const [isList, setIsList] = useState('list')
  const [categoryList, setCategoryList] = useState([])

  const { code } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  const query = queryString.parse(location.search)
  const { name, brand, group, view } = query

  const cateLoading = props.category.toJS().loading
  const display = props.product.toJS().display
  const { category } = display

  const getViewType = useCallback((val) => {
    switch (val) {
      case 'list':
        return 'list'
      case 'product':
        return 'product'
      default:
        return 'table'
    }
  }, [])

  useEffect(() => {
    if (loading) return
    try {
      props.product.initSelection(query)
    } catch (e) {}
  }, [props.product, loading])

  useEffect(() => {
    if (view) {
      setIsList(getViewType(view))
    } else {
      setIsList(getViewType(category.view_type))
    }
  }, [category.view_type, view, getViewType])

  const onGetList = useCallback(async () => {
    try {
      setLoading(true)
      const brand_list = await props.brand.getList()
      await props.product.getListByCategory({ code }, brand_list)
    } catch (e) {
      message.error({
        title: 'แสดงรายการหมวดหมู่',
        message: e.message,
      })
    }

    setLoading(false)
  }, [props.product, props.brand, code])

  useEffect(() => {
    onGetList()
  }, [onGetList])

  useEffect(() => {
    const {
      all_list = [],
    } = props.category.toJS()

    const find_category = props.category.findCategoryList(code, all_list)

    const { category = {}, original_list = [] } = find_category
    setContent(category)
    setCategoryList(original_list)
  }, [props.category, props.brand, code, cateLoading])

  const setUrl = (group, brand, list, isView) => {
    const gq = group || ''
    const bq = brand || ''
    const fq = product.buildFilterQuery(list)

    let query = ''
    if (gq !== '') {
      query += `&group=${gq}`
    }

    if (bq !== '') {
      query += `&brand=${bq}`
    }

    if (fq !== '') {
      query += `${fq}`
    }

    query += `&view=${isView}`
    navigate(`/product.list/${code}?name=${name}${query}`)
  }

  const onSelect = (item, n) => {
    const list = props.product.select(item, n)
    setUrl(group, brand, list, isList)
  }

  const onViewType = (val) => {
    setIsList(val)
    setUrl(group, brand, list, val)
  }

  const onSelectBrand = (item) => {
    const list = props.product.selectBrand(item)

    const q = product.buildQuery(list, 'code')
    setUrl(group, q, display.filter_list, isList)
  }

  const onSelectGroup = (item) => {
    const list = props.product.selectGroup(item)

    const q = product.buildQuery(list, 'name')
    setUrl(q, brand, display.filter_list, isList)
  }

  const onDisplayFilter = () => {
    const filter = document.getElementById('filter-body')
    if (filter) {
      const display = filter.style.display
      filter.style.display = display === 'block' ? 'none' : 'block'
    }
  }

  const getBtn = (name, icon, value) => {
    return (
      <Btn className={isList === value ? 'active' : undefined} onClick={() => onViewType(value)}>
        {name} {icon}
      </Btn>
    )
  }

  const list = display.list || []
  const product_content = loading === false && list.length > 0
  ? list.map((item, index) => {
    if (isList === 'product') {
      return (
        <ProductViewGroup
          key={index}
          item={item}
          isList={isList}
          prefix_url="/product" />
      )
    } else {
      return (
        <ProductGroup
          key={index}
          item={item}
          isList={isList}
          prefix_url="/product" />
      )
    }
  })
  : <NoProduct />

  return (
    <PageView>
      <Meta title={`ประเภทสินค้า-${content.name}`} />
      <BreadcrumbView category_list={categoryList}/>
      <Loading loading={loading || cateLoading} />
      <Title>
        <Text>
          {content.name}
        </Text>

        <Button>
          {getBtn('Grid', <BorderHorizontalOutlined />, 'product')}
          {getBtn('List', <UnorderedListOutlined />, 'list')}
          {getBtn('Table', <TableOutlined />, 'table')}
        </Button>
      </Title>
      <Detail>
        <HtmlContent content={content.detail} />
      </Detail>

      <ProductView
        display={display}
        onDisplayFilter={onDisplayFilter}
        onSelectGroup={onSelectGroup}
        onSelectBrand={onSelectBrand}
        onSelect={onSelect}>
        {product_content}
      </ProductView>
    </PageView>
  )
}

const PageView = styled.div`
  padding: 10px 0px;
`

const Title = styled.div`
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Text = styled.div`
  text-align: left;
  font-weight: bold;
`

const Button = styled.div`
  font-size: 14px;
`

const Btn = styled.span`
  padding: 0px 10px;
  cursor: pointer;

  &.active {
    color: #003e31;
  }
`

const Detail = styled.div`
  padding: 0px 10px;
`

export default inject('product', 'category', 'brand')(observer(ProductList))
